<template>
  <div>
    <div
      v-if="showManageFriendsButton"
      class="q-my-xs text-center add-friends"
      :class="$q.screen.lt.sm ? 'text-body1 text-bold' : 'text-h6'"
    >
      {{ $t('pages.manageFriends.wouldYouLikeToPurchaseTicketsForOtherMembers') }}
      <q-icon
        class="q-mb-xs"
        name="info"
        color="secondary"
      >
        <q-tooltip>{{ $register ? $t('pages.manageFriends.posAddFriendsToPurchaseTicketsTogether') : $t('pages.manageFriends.addFriendsToPurchaseTicketsTogether') }}</q-tooltip>
      </q-icon>
    </div>
    <div
      v-if="$register && showManageFriendsButton"
      class="row justify-center q-mr-sm q-my-sm"
    >
      <q-btn
        style="width: 225px;"
        :label="$t('user.actions.manageFriends')"
        icon="manage_accounts"
        color="secondary"
        @click="showManageFriends = true"
      />
    </div>
    <div
      class="row justify-center items-center q-mt-md q-mx-auto title"
      style="max-width: 500px; height: 10px;"
    >
      <span class="col line" />
      <div
        v-if="!showManageFriendsButton"
        class="q-px-sm col-auto"
      >
        {{ $t('membership.addFriendPrompt') }}.
      </div>
      <div
        v-else
        class="q-px-sm col-auto"
      >
        {{ $t('membership.linkAMemberPrompt') }}
      </div>
      <span class="col line" />
    </div>
    <div
      class="row justify-center q-mb-md q-py-md q-mx-auto border-right border-left border-bottom"
      :class="$q.screen.lt.sm ? 'q-gutter-x-xs' : 'q-gutter-x-sm'"
      style="max-width: 500px;"
    >
      <q-btn
        :dense="$q.screen.lt.sm"
        color="secondary"
        :text-color="buttonTextColor"
        icon="add_link"
        :label="$t('actions.link')"
        class="q-px-md"
        @click="$refs.authorizedPurchaserDialog.show(AUTHORIZATION_MODE.LINK)"
      />
      <q-btn
        :dense="$q.screen.lt.sm"
        color="secondary"
        :text-color="buttonTextColor"
        icon="card_membership"
        :label="$tc('card.card', 1)"
        class="q-px-md"
        @click="$refs.authorizedPurchaserDialog.show(AUTHORIZATION_MODE.CARD)"
      />
      <q-btn
        :dense="$q.screen.lt.sm"
        color="secondary"
        :text-color="buttonTextColor"
        icon="share"
        :label="$t('form.labels.emailAddress')"
        class="q-px-md"
        @click="$refs.authorizedPurchaserDialog.show(AUTHORIZATION_MODE.EMAIL)"
      />
    </div>
    <authorized-purchaser-dialog
      ref="authorizedPurchaserDialog"
      :user="user"
    />
    <q-dialog
      v-model="showManageFriends"
    >
      <q-card :style="$q.screen.lt.sm ? '' : 'min-width: 600px;'">
        <q-card-section class="row items-center q-mx-xs q-mb-sm">
          <div
            class="text-h6 text-center"
          >
            {{ $t('user.actions.manageFriends') }}
          </div>
          <q-space />
          <q-btn
            icon="close"
            flat
            round
            dense
            @click="showManageFriends = false"
          />
        </q-card-section>
        <q-card-section>
          <manage-friends
            :user="user"
          />
        </q-card-section>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>

import User from 'src/models/user/User'
import AuthorizedPurchaserDialog, { AUTHORIZATION_MODE } from 'src/modules/consumer/components/AuthorizedPurchaserDialog'
import ManageFriends from 'src/modules/consumer/components/ManageFriends'

export default {
  name: 'AddFriends',
  configuration: ['currentSite'],
  components: {
    AuthorizedPurchaserDialog,
    ManageFriends
  },
  context: ['currentUser'],
  props: {
    user: {
      type: User,
      required: false,
      default: null
    },
    showManageFriendsButton: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data: function () {
    return {
      showManageFriends: false
    }
  },
  computed: {
    activeUser () {
      return this.user || this.currentUser
    },
    buttonTextColor () {
      return this.$isColorDark(this.currentSite.secondaryColor) ? 'white' : 'black'
    }
  },
  created () {
    _.extend(this, { AUTHORIZATION_MODE })
  }
}
</script>

<style lang="scss" scoped>
 .bg-background {
  background-color: $background
 }
 .line{
  height: 1px;
  background: $grey-4;
 }
</style>
